// frontend/src/components/Header.js
import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="app-header">
      <div className="header-logo">
        CallCenter<strong>App</strong>
      </div>
      <div className="header-operator">
        <span>Bem-vindo, <strong>Operador</strong></span>
        <div className="status-indicator online"></div>
      </div>
    </header>
  );
};

export default Header;